import { Directive, HostListener, inject } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
  selector: '[coreGoBack]',
  standalone: true,
})
export class GoBackDirective {
  private location = inject(Location);

  @HostListener('click')
  onClick(): void {
    this.location.back();
  }
}
